<template>
    <v-container grid-list-xs fluid>
        <v-card>
            <v-toolbar dark color="secondary" class="white--text" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title> Product Code </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-data-table
                    v-if="toggle"
                    :headers="headers"
                    :items="relations"
                    hide-actions
                    :search="search"
                    fixed-header
                    height="650px"
                >
                    <template v-slot:top>
                        <v-card-title>
                            <v-text-field
                                v-model="search"
                                label="Search"
                                append-icon="mdi-magnify"
                                dense
                                hide-details
                            >
                            </v-text-field>
                            <v-btn class="mr-4" @click="toggle = !toggle" icon
                                ><v-icon>mdi-swap-horizontal</v-icon></v-btn
                            >
                            <v-spacer />
                            <v-spacer />
                            <v-btn
                                class="ml-1"
                                large
                                color="secondary"
                                icon
                                @click="$store.state.productCode.create = true"
                            >
                                <v-icon icon>mdi-plus-circle</v-icon>
                            </v-btn>
                        </v-card-title>
                    </template>
                    <template v-slot:item.Active="{ item }">
                        <v-switch
                            v-model="item.Active"
                            class="mr-3"
                            color="secondary"
                            dense
                            hide-details
                            @change="changeState(item)"
                        >
                        </v-switch>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon small class="mx-3" @click="edit(item)"
                            >mdi-pencil</v-icon
                        >
                        <!-- <v-icon small @click="deleteItem(item)">mdi-delete</v-icon> -->
                    </template>
                </v-data-table>
                <v-data-table
                    v-else
                    :headers="lnHeader"
                    :items="combinations"
                    dense
                >
                    <template v-slot:top>
                        <v-row>
                            <v-col cols="5">
                                <v-text-field
                                    v-model="search"
                                    label="Search"
                                    append-icon="mdi-magnify"
                                    dense
                                >
                                </v-text-field
                            ></v-col>
                            <v-btn
                                class="mr-4 mt-3"
                                @click="toggle = !toggle"
                                icon
                                ><v-icon>mdi-swap-horizontal</v-icon></v-btn
                            >
                        </v-row>
                    </template>

                    <template v-slot:item.LoadingNumber="{ item }">
                        <v-text-field
                            v-model="item.LoadingNumber"
                            dense
                            hide-details
                            @change="changeLoadingNumber(item)"
                        ></v-text-field>
                    </template>
                </v-data-table>
                <newProductCode
                    v-if="$store.state.productCode.create"
                    :relation="relations"
                ></newProductCode>
                <EditProductCode
                    v-if="$store.state.productCode.edit"
                    :edt="dataEdt"
                    :relation="relations"
                >
                </EditProductCode>
            </v-container>
        </v-card>
    </v-container>
</template>
<script>
import newProductCode from '../Modals/Dispatch/ProductCode/NewProductCode.vue';
import EditProductCode from '../Modals/Dispatch/ProductCode/EditProductCode.vue';
import axios from 'axios';
export default {
    name: 'Drivers',
    components: {
        newProductCode,
        EditProductCode
    },
    data: function() {
        return {
            dataEdt: [],
            dialog: false,
            dataLoading: true,
            relations: [],
            headers: [
                { text: 'ID', value: 'ID', width: '2%' },
                { text: 'Customer', value: 'customer.Name', width: '15%' },
                {
                    text: 'Terminal',
                    value: 'terminal.TerminalName',
                    width: '15%'
                },
                { text: 'Supplier', value: 'supplier.Supplier', width: '10%' },
                { text: 'Product', value: 'product.Product', width: '10%' },
                { text: 'ProductCode', value: 'Code', width: '10%' },
                { text: 'Consignor', value: 'Consignor', width: '10%' },
                { text: 'Consignee', value: 'Consignee', width: '10%' },
                { text: 'Destination', value: 'Destination', width: '10%' },
                { text: 'Active', value: 'Active', width: '10%' },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                    width: '5%'
                }
            ],
            lnHeader: [
                { text: 'Total', value: 'Total', width: '5%' },
                { text: 'Customer', value: 'Customer', width: '15%' },
                { text: 'Terminal', value: 'TerminalName', width: '15%' },
                { text: 'Supplier', value: 'Supplier', width: '10%' },
                { text: 'LoadingNumber', value: 'LoadingNumber', width: '10%' }
            ],
            combinations: [],
            toggle: true,
            search: '',
            drivers: []
        };
    },

    computed: {
        formTitle() {
            return this.edited.id === 0 ? 'New Item' : 'Edit Item';
        }
    },

    watch: {
        '$store.state.productCode.watch': function() {
            if (this.$store.state.productCode.watch == true) {
                this.loadProducCode();
                this.$store.state.productCode.watch = false;
            }
        }
    },

    mounted() {
        this.loadProducCode();
        this.loadCombinations();
    },

    methods: {
        loadProducCode: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .get('realation-product-code')
                .then(response => {
                    this.relations = response.data;
                    console.log(this.relations);
                    this.dataLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        loadCombinations: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .get('get-product-code-number/combinations')
                .then(response => {
                    this.combinations = response.data;
                    console.log(this.combinations);
                    this.dataLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        edit: function(item) {
            this.dataEdt = item;
            this.$store.state.productCode.edit = true;
        },
        changeState: function(item) {
            this.edited = Object.assign({}, item);
            var str = this.$store;
            var params = {
                Active: this.edited.Active
            };
            axios
                .put('realation-product-code/' + this.edited.ID, params)
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Station Advice status changed.'
                    });
                    this.loadProducCode();
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        changeLoadingNumber: function(item) {
            var str = this.$store;
            axios
                .post('realation-product-code/combination/loading-number', item)
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Station Advice status changed.'
                    });
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        }
    }
};
</script>
